// extracted by mini-css-extract-plugin
module.exports = {"Information":"Information_Information__1H8n0"};